module.exports = {
    // Navigation page translations
    banner: {
        title: {
            en: `<span class="heading heading--banner"><strong>Examination closed on 16 January 2025. To sign up to receive project updates, please <a href="https://infrastructure.planninginspectorate.gov.uk/projects/wales/mona-offshore-wind-farm/" target="_blank">click here</a>.</strong></span>`,
            cym: `<span class="heading heading--banner"><strong>Mae ein cais am gydsyniad datblygu wedi cael ei dderbyn i gael ei archwilio. Cliciwch <a target="_blank" href="https://infrastructure.planninginspectorate.gov.uk/cy/projects/fferm-wynt-alltraeth-mona/">yma</a> i weld dogfennau’r cais. Cliciwch <a target="_blank" href="/assets/files/CYMRAEG-Mona-Hydref-Hearings-hysbysiad.pdf">yma</a> i weld hysbysiad sy’n cyhoeddi dyddiadau ac amseroedd y gwrandawiadau archwilio.</strong></span>`
        },
        home: {
            en: "Back Home",
            cym: "Hafan",
        },


    },
    nav: {
        home: {
            title: {
                en: "Home",
                cym: "Cartref",
            },
            slug: {
                en: "",
                cym: "",
            },
            welcome: {
                title: {
                    en: "Welcome",
                    cym: "Croeso",
                },
                slug: {
                    en: "",
                    cym: "",
                },
            },
            whoAreEnbwAndBp: {
                title: {
                    en: "Who are EnBW and bp?",
                    cym: "Pwy yw EnBW a bp?",
                },
                slug: {
                    en: "who-are-enbw-and-bp",
                    cym: "pwy-yw-enbw-a-bp",
                },
            },
        },
        overview: {
            title: {
                en: "Offshore wind",
                cym: "Offshore wind",
            },
            slug: {
                en: "overview",
                cym: "trosolwg",
            },
            whyWeNeedOffshoreWind: {
                title: {
                    en: "Why we need offshore wind",
                    cym: "Why we need offshore wind",
                },
                slug: {
                    en: "why-we-need-offshore-wind",
                    cym: "why-we-need-offshore-wind",
                },
            },
            howOffshoreWindFarmsWork: {
                title: {
                    en: "How offshore wind farms work",
                    cym: "How offshore wind farms work",
                },
                slug: {
                    en: "how-offshore-wind-farms-work",
                    cym: "how-offshore-wind-farms-work",
                },
            },
        },
        proposals: {
            title: {
                en: "Proposals",
                cym: "Ein cynigion",
            },
            slug: {
                en: "proposals",
                cym: "ein-cynigion",
            },
            construction: {
                title: {
                    en: "Construction",
                    cym: "Adeiladu",
                },
                slug: {
                    en: "construction",
                    cym: "adeiladu",
                },
            },
            timeline: {
                title: {
                    en: "Indicative project timeline",
                    cym: "Indicative project timeline",
                },
                slug: {
                    en: "indicative-timeline",
                    cym: "indicative-timeline",
                },
            },
            supporting: {
                title: {
                    en: "Supporting the local, regional and national economy",
                    cym: "Cefnogi’r economi leol, ranbarthol a chenedlaethol",
                },
                slug: {
                    en: "supporting-the-local-regional-and-national-economy",
                    cym: "cefnogir-economi-leol-ranbarthol-a-chenedlaethol",
                },
            },
            commercial: {
                title: {
                    en: "Commercial fisheries, shipping and navigation",
                    cym: "Pysgodfeydd masnachol, llongau a mordwyo",
                },
                slug: {
                    en: "commercial-fisheries-shipping-navigation",
                    cym: "pysgodfeydd-masnachol-llongau-a-mordwyo",
                },
            },
        },
        proposedChanges: {
            title: {
                en: "Proposed changes",
                cym: "Newidiadau arfaethedig",
            },
            slug: {
                en: "proposed-changes",
                cym: "newidiadau-arfaethedig",
            },
        },
        newsDocuments: {
            title: {
                en: "News and documents",
                cym: "Hyb gwybodaeth",
            },
            slug: {
                en: "news-documents",
                cym: "hyb-ymgynghori",
            },
        },
        haveYourSay: {
            title: {
                en: "Have your say",
                cym: "Dweud eich dweud",
            },
            slug: {
                en: "have-your-say",
                cym: "have-your-say",
            },
            consultationEvents: {
                title: {
                    en: "Consultation events",
                    cym: "Digwyddiadau ymgynghori",
                },

                slug: {
                    en: "consultation-events",
                    cym: "digwyddiadau-ymgynghori",
                },
            },
            feedbackForm: {
                title: {
                    en: "Submitting feedback",
                    cym: "Cyflwyno adborth",
                },

                slug: {
                    en: "form/your-details",
                    cym: "form/your-details",
                },
            },
            consultationMapHow: {
                title: {
                    en: "How to use our consultation map",
                    cym: "Sut i ddefnyddio ein map ymgynghori",
                },

                slug: {
                    en: "using-consultation-map",
                    cym: "using-consultation-map",

                },
            },
            consultationMap: {
                title: {
                    en: "Consultation map",
                    cym: "Map ymgynghori",
                },

                slug: {
                    en: "Consultation-map",
                    cym: "map-ymgynghori",

                },
                url: {
                    en: "https://feedback.morganandmona.com/en",
                    cym: "https://feedback.morganandmona.com/cy",
                }
            },
            visualisations: {
                title: {
                    en: "Visualisations",
                    cym: "Delweddu",
                },

                slug: {
                    en: "visualisation-map",
                    cym: "visualisation-map",

                },
            },
        },
        contactUs: {
            title: {
                en: "Contact us",
                cym: "Cysylltu",
            },

            slug: {
                en: "contact",
                cym: "cysylltu",
            },
        },
    },

    // Partials site translations
    partials: {
        pasteWarning: {
            en: "When copy and pasting, please be sure to double check your answers before submitting.",
            cym: "Wrth gopïo a gludo, gwnewch yn siŵr eich bod yn gwirio'ch atebion ddwywaith cyn eu cyflwyno."
        },

        contactUs: {
            title: {
                en: "Contact us",
                cym: "Cysylltwch â ni",
            },

            description: {
                en: "You can get in touch with us here.",
                cym: "Gallwch gysylltu â ni yma.",
            },

            cta: {
                en: "Get in touch",
                cym: "Cysylltwch",
            },
        },

        substationOptions: {
            title: {
                en: "Substation Options",
                cym: "Ymgynghoriad cyhoeddus",
            },
        },

        consultationEvents: {
            title: {
                en: "Consultation events",
                cym: "Digwyddiadau ymgynghori",
            },

            description: {
                en: "We encourage you to come along to one of our in-person or online public consultation events. Visit our meet the teams page for more information about our events.",
                cym: "We encourage you to come along to one of our in-person or online public consultation events. Visit our meet the teams page for more information about our events.",
            },

            cta: {
                en: "Find and event",
                cym: "Darganfod a digwyddiad",
            },
        },

        webinar: {
            title: {
                en: "Online webinar event",
                cym: "Digwyddiad gweminar ar-lein",
            },

            description: {
                en: "Watch the recording of our online consultation event, broadcast on 9 May 2023",
                cym: "Gwyliwch recordiad o’n digwyddiad ymgynghori ar-lein, a ddarlledwyd ar 9 Mai 2023",
            },

            cta: {
                en: "Watch recording",
                cym: "Gwylio recordiad",
            },
            id: {
                en: "825444258",
                cym: "825444258",
            },
        },

        register: {
            title: {
                en: "Register for updates",
                cym: "Cofrestrwch i gael diweddariadau",
            },

            description: {
                en: "Please register your details with us if you would like to be kept informed about our project.",
                cym: "Cofrestrwch eich manylion gyda ni os hoffech gael gwybod am ein prosiect.",
            },

            cta: {
                en: "Register here",
                cym: "cofrestrwch yma",
            },
            slug: {
                en: "/en/contact/",
                cym: "/cym/cysylltu/",
            },

        },


        consultationOpen: {
            title: {
                en: "Public consultation",
                cym: "Ymgynghoriad cyhoeddus",
            },

            date: {
                en: "26 September to 7 November 2022",
                cym: "26 Medi i 7 Tachwedd 2022",
            },

            description: {
                en: "Find out more about what we're consulting on and how you can take part.",
                cym: "Dysgwch fwy am yr hyn yr ydym yn ymgynghori arno a sut y gallwch gymryd rhan.",
            },

            cta: {
                en: "Consultation",
                cym: "Ymgynghoriad",
            },
            slug: {
                en: "have-your-say/",
                cym: "dweud-eich-dweud/",
            },
        },

        consultationClosed: {
            title: {
                en: "Consultation closed",
                cym: "Daeth yr ymgynghoriad i ben",
            },

            message: {
                en: "This consultation is closed and is no longer accepting feedback.",
                cym: "Mae'r ymgynghoriad hwn wedi dod i ben ac nid yw bellach yn derbyn adborth.",
            },
        },

        interactiveMap: {
            title: {
                en: "Interactive Map",
                cym: "Eich adborth",
            },

            description: {
                en: "View interactive map of the Mona offshore wind project",
                cym: "Dweud eich dweud ar ein cynigion.",
            },

            cta: {
                en: "Interactive map",
                cym: "Map adborth",
            },
        },

        consultationMap: {
            title: {
                en: "Your feedback",
                cym: "Adborth",
            },

            description: {
                en: "Have your say on our proposals.",
                cym: "Dweud eich dweud ar ein cynigion.",
            },

            cta: {
                en: "Consultation map",
                cym: "Map ymgynghori",
            },
        },
        visualisationPanel: {
            title: {
                en: "Visualisation",
                cym: "Delweddau",
            },

            description: {
                en: "The exact number, size and layout of our wind turbine generators is still being developed. However, at this early stage, we've created indicative 3D visualisations to show potential views of the Mona and Morgan wind farms from a range of onshore locations.",
                cym: "Rydym dal yn cynllunio union nifer, maint a ffurfweddiad y generaduron tyrbinau gwynt. Fodd bynnag, yn y cyfnod cynnar hwn, rydym wedi creu delweddu 3D dangosol i ddangos golygfeydd posibl o ffermydd gwynt Mona a Morgan o ystod o leoliadau ar y tir.",
            },

            cta: {
                en: "View map",
                cym: "Gweld map",
            },
        },
        consultationHubPanel: {
            title: {
                en: "Consultation hub",
                cym: "Hyb ymgynghori",
            },

            header: {
                en: "Our statutory consultation on our latest proposals closed on Sunday 4 June 2023.",
                cym: "Daeth ein hymgynghoriad statudol ar ein cynigion diweddaraf i ben ddydd Sul 4 Mehefin 2023.",
            },

            description: {
                en: "This was our second consultation on the latest design of the project. To view all materials relating to our recent statutory consultation. This includes our Preliminary Environmental Information Report (or ‘PEIR’), which formed the basis of our recent consultation.",
                cym: "Hwn oedd ein hail ymgynghoriad ar ddyluniad diweddaraf y prosiect. Gweld yr holl ddeunyddiau sy'n ymwneud â'n hymgynghoriad statudol diweddar. Mae hyn yn cynnwys ein Hadroddiad Gwybodaeth Amgylcheddol Ragarweiniol (neu ‘PEIR’), a oedd yn sail i’n hymgynghoriad diweddar.",
            },

            cta: {
                en: "View information hub",
                cym: "Gweld hyb gwybodaeth ",
            },
        },

        downloads: {
            title: {
                en: "Downloads",
                cym: "Lawrlwythiadau",
            },

            description: {
                en: "Download and view our consultation materials.",
                cym: "Lawrlwythwch a gweld ein deunyddiau ymgynghori.",
            },

            cta: {
                en: "View downloads",
                cym: "Gweld lawrlwythiadau",
            },

            slug: {
                en: "downloads",
                cym: "lawrlwythiadau",
            },
        },

        feedbackUnavailable: {
            title: {
                en: "Feedback unavailable",
                cym: "Nid yw adborth ar gael",
            },

            description: {
                en: "Your browser is set to disallow 3rd party cookies which are required for this feedback form to work correctly. Please disable private browsing in your browser or contact us for support.",
                cym: "Mae eich porwr wedi'i osod i wrthod cwcis trydydd parti sy'n ofynnol er mwyn i'r ffurflen adborth hon weithio'n gywir. Analluoga pori preifat yn eich porwr neu cysylltwch â ni am gefnogaeth.",
            },
        },

        imageZoomCaption: {
            mobile: {
                en: "Pinch to zoom",
                cym: "Pinsiad i chwyddo",
            },

            desktop: {
                en: "Click image to enlarge",
                cym: "Cliciwch ar y llun i'w ehangu",
            },
        },

        cookiePolicy: {
            title: {
                en: "Cookie policy",
                cym: "Polisi cwcis",
            },

            slug: {
                en: "cookies",
                cym: "briwsion",
            },
        },

        captchaNotice: {
            en: `To submit this form, <a href="/en/cookies" class="text-secondary">the use of cookies must be accepted</a>.<br>This is necessary to enable the user to complete a human-only response from a reCAPTCHA.`,
            cym: `I gyflwyno'r adborth hon, <a href="/cym/briwsion" class="text-secondary">rhaid derbyn y defnydd o gwcis</a>.<br>Mae hyn yn angenrheidiol i alluogi'r defnyddiwr i gwblhau ymateb dynol yn unig o reCAPTCHA.`
        },

        copyright: {
            en: "All rights reserved © Copyright",
            cym: "Cedwir pob hawl © Hawlfraint",
        },

        privacyPolicy: {
            title: {
                en: "Privacy policy",
                cym: "Polisi preifatrwydd",
            },

            slug: {
                en: "privacy",
                cym: "preifatrwydd",
            },
        },
    },

    // Miscellaneous translations
    misc: {
        notFound: {
            title: {
                en: "Page not found",
                cym: "Tudalen heb ei chanfod",
            },

            description: {
                en: "This page has been moved or does not exist.",
                cym: "Mae'r dudalen hon wedi'i symud neu nid yw'n bodoli.",
            },

            backHome: {
                en: "Back home",
                cym: "Yn ôl adref",
            },
        },

        map: {
            showExisting: {
                en: "Show existing",
                cym: "Golygfa rŵan",
            },

            showProposed: {
                en: "Show proposed",
                cym: "Golygfa arfaethedig",
            },

            proposedAt: {
                en: "Proposed",
                cym: "Arfaethedig",
            },

            existingAt: {
                en: "Existing",
                cym: "Rŵan",
            },
        },
    },

    // Feedback translations
    feedback: {
        title: {
            en: "Feedback form",
            cym: "Ffurflen adborth",
        },

        feedbackSections: {
            en: "Feedback sections",
            cym: "Adrannau adborth",

            complete: {
                en: "Complete",
                cym: "Cyflawn",
            },

            required: {
                en: "Required",
                cym: "Gofynnol",
            },
        },

        sectionComplete: {
            title: {
                en: "Section complete",
                cym: "Adran wedi'i chwblhau",
            },

            description: {
                en: "Use the form below to update your answers for this section.",
                cym: "Defnyddiwch y ffurflen isod i ddiweddaru eich atebion ar gyfer yr adran hon.",
            },
        },

        feedbackProgress: {
            title: {
                en: "Feedback progress",
                cym: "Cynnydd adborth",
            },

            description: {
                en: "sections completed",
                cym: "adrannau wedi'u cwblhau",
            },

            cta: {
                en: "Review feedback",
                cym: "Adolygu adborth",
            },

            viewYourProgress: {
                title: {
                    en: "View your progress",
                    cym: "Gweld eich cynnydd",
                },

                description: {
                    en: "See your feedback progress here. Ready to submit your feedback? Click Review feedback",
                    cym: "Gweler eich cynnydd adborth yma. Yn barod i gyflwyno eich adborth? Cliciwch Adolygu adborth",
                },

                close: {
                    en: "Close",
                    cym: "Cau",
                },
            },
        },

        yourDetails: {
            en: "Your details",
            cym: "Eich manylion",
        },

        enterYourFeedback: {
            title: {
                en: "Enter your feedback",
                cym: "Rhowch eich adborth",
            },

            description: {
                en: "Use the form below to enter your feedback. You can come back and update this later if you wish.",
                cym: "Defnyddiwch y ffurflen isod i roi eich adborth. Gallwch ddod yn ôl a diweddaru hwn yn ddiweddarach os dymunwch.",
            },

            close: {
                en: "Close",
                cym: "Cau",
            },
        },

        reviewYourFeedback: {
            title: {
                en: "Review your feedback",
                cym: "Adolygwch eich adborth",
            },

            description: {
                en: "This page shows the feedback you have entered so far for your review. When satisfied with your response, complete your details to submit your feedback at the bottom of this page.",
                cym: "Mae'r dudalen hon yn dangos yr adborth rydych chi wedi'i nodi hyd yn hyn ar gyfer eich adolygiad. Pan fyddwch yn fodlon â'ch ymateb, cwblhewch eich manylion i gyflwyno'ch adborth ar waelod y dudalen hon.",
            },

            close: {
                en: "Close",
                cym: "Cau",
            },

            question: {
                en: "Question",
                cym: "Cwestiwn",
            },

            yourResponse: {
                en: "Your response",
                cym: "Eich ymateb",
            },

            completeYourDetails: {
                en: `Please <a href="/en/have-your-say/form/your-details/" class="text-dark">complete your details</a> to submit your feedback`,
                cym: `Os gwelwch yn dda <a href="/cym/have-your-say/form/your-details/" class="text-dark">cwblhewch eich manylion</a> i gyflwyno eich adborth`,
            },
        },

        addToFeedback: {
            en: "Add to my feedback",
            cym: "Ychwanegu at adborth",
        },

        updateFeedback: {
            en: "Update my feedback",
            cym: "Diweddaru adborth",
        },

        viewYourProgress: {
            title: {
                en: "View your progress",
                cym: "Gweld eich cynnydd",
            },

            description: {
                en: "See your feedback progress here. Ready to submit your feedback? Click Review feedback",
                cym: "Gweler eich cynnydd adborth yma. Yn barod i gyflwyno eich adborth? Cliciwch Adolygu adborth",
            },

            close: {
                en: "Close",
                cym: "Cau",
            },
        },

        submitYourFeedback: {
            en: "Submit your feedback",
            cym: "Cyflwyno'ch adborth",
        },

        successfulFeedback: {
            title: {
                en: "Successful feedback",
                cym: "Adborth llwyddiannus",
            },

            subtitle: {
                en: "Your feedback has been submitted",
                cym: "Mae eich adborth wedi'i gyflwyno",
            },

            description: {
                en: "Thank you for submitting your feedback. We will review all your comments alongside other feedback and take them into account as we prepare our planning application.",
                cym: "Diolch i chi am gyflwyno eich adborth. Byddwn yn adolygu eich holl sylwadau ochr yn ochr ag adborth arall ac yn eu cymryd i ystyriaeth wrth i ni baratoi ein cais cynllunio.",
            },
        },

        questions: {
            1: {
                question: {
                    en: "Do you have any comments / feedback on the offshore elements of the Mona Offshore Wind Project generally? You may choose to comment on the specific topics listed (see numbered topics 1.1 to 1.14 below). These topics are set out in detail in our Preliminary Environmental Information Report (PEIR) and more succinctly summarised in our PEIR Non-Technical Summary (both available to read in full at www.morganandmona.com)",
                    cym: "A oes gennych unrhyw sylwadau / adborth ar elfennau alltraeth Prosiect Gwynt Alltraeth Mona yn gyffredinol? Gallwch ddewis rhoi sylwadau ar y pynciau penodol a restrir (gweler y pynciau wedi'u rhifo 1.1 i 1.14 isod). Nodir y pynciau hyn yn fanwl yn ein Hadroddiad Gwybodaeth Amgylcheddol Ragarweiniol (PEIR) a chânt eu crynhoi yng Nghrynodeb Annhechnegol y PEIR (mae’r ddau ar gael i’w darllen yn llawn yn www.morganandmona.com).",
                },
            },

            2: {
                question: {
                    en: "Do you have any comments or feedback on the onshore elements of the Mona Offshore Wind Project generally? You may choose to comment on the specific topics listed (see numbered topics 2.1 to 2.15 below). These topics are set out in detail in our Preliminary Environmental Information Report (PEIR) and more succinctly summarised in our PEIR Non-Technical Summary (both available to read in full at www.morganandmona.com).",
                    cym: "A oes gennych unrhyw sylwadau neu adborth ar elfennau ar y tir Prosiect Gwynt Alltraeth Mona yn gyffredinol? Gallwch ddewis rhoi sylwadau ar y pynciau penodol a restrir (gweler y pynciau wedi'u rhifo 2.1 i 2.15 isod). Nodir y pynciau hyn yn fanwl yn ein Hadroddiad Gwybodaeth Amgylcheddol Ragarweiniol (PEIR) a chânt eu crynhoi yng Nghrynodeb Annhechnegol y PEIR (mae’r ddau ar gael i’w darllen yn llawn yn www.morganandmona.com).",
                },
            },

            3: {
                question: {
                    en: "Do you have comments on how the project could support and work with local, regional and national communities and the economy?",
                    cym: "A oes gennych sylwadau ar sut y gallai’r prosiect gefnogi a gweithio gyda chymunedau lleol, rhanbarthol a chenedlaethol, a’r economi?",
                },
            },

            4: {
                question: {
                    en: "Do you have any comments / feedback on how we have understood the technical and environmental constraints of the areas offered to us by the Crown Estate as part of its leasing process? This work informed our decision to locate Mona Offshore Wind Project at the proposed wind farm site. The constraints which were analysed and considered included water depths, wind capacity, wave height, seabed conditions, and the location of possible onshore connection and marine port facilities (among other things). See Volume 1 of our PEIR, Introductory Chapters, chapter 3: Project Description.",
                    cym: "A oes gennych unrhyw sylwadau / adborth ar sut rydym wedi deall cyfyngiadau technegol ac amgylcheddol yr ardaloedd a gynigir i ni gan Ystad y Goron fel rhan o’i phroses brydlesu? Fe lywiodd y gwaith hwn ein penderfyniad i leoli Prosiect Gwynt Alltraeth Mona ar y safle arfaethedig. Roedd y cyfyngiadau a gafodd eu dadansoddi a’u hystyried yn cynnwys dyfnder dŵr, capasiti gwynt, uchder tonnau, amodau gwely’r môr, a lleoliad cysylltiad posibl ar y tir a chyfleusterau porthladd morol (ymhlith pethau eraill). Edrychwch ar Gyfrol 1 yr adroddiad, Penodau Rhagarweiniol, pennod 3: Disgrifiad o’r Prosiect.",
                },
            },

            5: {
                question: {
                    en: "Do you have any comments / feedback about the location of the landfall compound zone for the Mona Offshore Wind Project? See Volume 1 of our PEIR, Introductory Chapters, chapter 4: Site Selection and Consideration of Alternatives.",
                    cym: "A oes gennych unrhyw sylwadau / adborth am leoliad parth y lanfa ar gyfer Prosiect Gwynt Alltraeth Mona? Edrychwch ar Gyfrol 1 yr adroddiad, Penodau Rhagarweiniol, pennod 4: Dewis Safle ac Ystyried Dewisiadau Amgen.",
                },
            },

            6: {
                question: {
                    en: "Do you have any comments / feedback that will help us refine our onshore cable route for the Mona Offshore Wind Project ahead of submitting our application? See Volume 1 of our PEIR, Introductory Chapters, chapter 4: Site Selection and Consideration of Alternatives.",
                    cym: "A oes gennych unrhyw sylwadau / adborth a fydd yn ein helpu i fireinio ein llwybr ceblau ar y tir ar gyfer Prosiect Gwynt Alltraeth Mona cyn cyflwyno ein cais? Edrychwch ar Gyfrol 1 yr adroddiad, Penodau Rhagarweiniol, pennod 4: Dewis Safle ac Ystyried Dewisiadau Amgen",
                },
            },
            7: {
                question: {
                    en: "For our application we will be reducing to a single onshore substation zone. Do you have any comments, feedback or preference regarding the onshore substation zones proposed for the Mona Offshore Wind Project and which one should be taken forward? See Volume 1 of our PEIR, Introductory Chapters, chapter 4: Site Selection and Consideration of Alternatives.",
                    cym: "Ar gyfer ein cais byddwn yn lleihau i un parth is-orsaf ar y tir. A oes gennych unrhyw sylwadau, adborth neu ffafriaeth ynghylch y parthau is-orsaf ar y tir a gynigir ar gyfer Prosiect Gwynt Alltraeth Mona a pha un y dylid ei ddewis? Edrychwch ar Gyfrol 1 yr adroddiad, Penodau Rhagarweiniol, pennod 4: Dewis Safle ac Ystyried Dewisiadau Amgen.",
                },
            },
            8: {
                question: {
                    en: "Do you have any comments / feedback on how we propose to minimise and mitigate the onshore impacts of our work, including any construction impacts? This might include your comments on our Code of Construction Practice and its appendices. See Volume 1 of our PEIR, Introductory Chapter, chapter 3: Project Description.",
                    cym: "A oes gennych unrhyw sylwadau / adborth ar sut rydym yn bwriadu lleihau a lliniaru effeithiau ein gwaith ar y tir, gan gynnwys unrhyw effeithiau adeiladu? Gallai hyn gynnwys eich sylwadau ar ein Cod Ymarfer Adeiladu a'i atodiadau. Gweler Cyfrol 1 yr adroddiad, Penodau Rhagarweiniol, pennod 3: Disgrifiad o’r Prosiect.",
                },
            },
            9: {
                question: {
                    en: "Do you have any other comments / feedback on the project, including any other information provided as a part of this consultation?",
                    cym: "A oes gennych unrhyw sylwadau / adborth arall ar y prosiect, gan gynnwys unrhyw wybodaeth arall a ddarparwyd fel rhan o’r ymgynghoriad hwn?",
                },
            },
        },

        successUrl: {
            en: "success",
            cym: "llwyddiant",
        },

        themes: [
            {
                name: {
                    en: "Offshore",
                    cym: "Ar y môr",
                },
                url: "section-1",
                feedback_url: "",
                icon: "offshore",
                key: "01-section",
                questionKey: [
                    {
                        label: "questionOne",
                    },
                ],
                topics: [
                    {
                        "key": "01-question-01-topic",
                        "question": {
                            en: "Marine geology, oceanography and physical processes (see Chapter 6 of our PEIR)",
                            cym: "Daeareg forol, cefnforeg a phrosesau ffisegol (edrychwch ar Bennod 6 yr adroddiad)",
                        },
                    },
                    {
                        "key": "01-question-02-topic",
                        "question": {
                            en: "Marine sediment and water quality (see Volume 6 Chapter 2.2 of our PEIR)",
                            cym: "Ansawdd dŵr a gwaddodion morol (edrychwch ar Gyfrol 6, Pennod 2.2 yr adroddiad)",
                        },
                    },
                    {
                        "key": "01-question-03-topic",
                        "question": {
                            en: "Benthic ecology (see Chapter 7 of our PEIR)",
                            cym: "Ecoleg Benthig (edrychwch ar Bennod 7 yr adroddiad)",
                        },
                    },
                    {
                        "key": "01-question-04-topic",
                        "question": {
                            en: "Fish and shellfish ecology (see Chapter 8 of our PEIR)",
                            cym: "Ecoleg pysgod a physgod cregyn (edrychwch ar Bennod 8 yr adroddiad)",
                        },
                    },
                    {
                        "key": "01-question-05-topic",
                        "question": {
                            en: "Marine mammals (see Chapter 9 of our PEIR)",
                            cym: "Mamaliaid morol (edrychwch ar Bennod 9 yr adroddiad) ",
                        },
                    },
                    {
                        "key": "01-question-06-topic",
                        "question": {
                            en: "Offshore ornithology (see Chapter 10 of our PEIR)",
                            cym: "Adareg ar y môr (edrychwch ar Bennod 10 yr adroddiad)",
                        },
                    },
                    {
                        "key": "01-question-07-topic",
                        "question": {
                            en: "Commercial fisheries (see Chapter 11 of our PEIR)",
                            cym: "Pysgodfeydd masnachol (edrychwch ar Bennod 11 yr adroddiad)",
                        },
                    },
                    {
                        "key": "01-question-08-topic",
                        "question": {
                            en: "Shipping and navigation (see Chapter 12 of our PEIR)",
                            cym: "Morgludiant a mordwyo (edrychwch ar Bennod 12 yr adroddiad)",
                        },
                    },
                    {
                        "key": "01-question-09-topic",
                        "question": {
                            en: "Marine archaeology (see Volume 2, Chapter 13 of our PEIR)",
                            cym: "Archaeoleg y môr (edrychwch ar Gyfrol 2, Pennod 13 yr adroddiad)",
                        },
                    },
                    {
                        "key": "01-question-10-topic",
                        "question": {
                            en: "Civil and military aviation and radar (see Chapter 27 of our PEIR)",
                            cym: "Hediadau a radar sifil a milwrol (edrychwch ar Bennod 27 yr adroddiad)",
                        },
                    },
                    {
                        "key": "01-question-11-topic",
                        "question": {
                            en: "Other sea users (see Volume 2, Chapter 14 of our PEIR)",
                            cym: "Defnyddwyr eraill y môr (edrychwch ar Gyfrol 2, Pennod 14 yr adroddiad)",
                        },
                    },
                    {
                        "key": "01-question-12-topic",
                        "question": {
                            en: "Seascape, Landscape and Visual Impact Assessment (see page 26 of our PEIR)",
                            cym: "Asesiad o'r Effaith Weledol a'r Effaith ar y Morwedd a'r Dirwedd (SLVIA) (edrychwch ar Bennod 26 yr adroddiad)",
                        },
                    },
                    {
                        "key": "01-question-13-topic",
                        "question": {
                            en: "Physical processes (see Chapter 6 of our PEIR)",
                            cym: "Prosesau ffisegol (edrychwch ar Bennod 6 yr adroddiad)",
                        },
                    },
                    {
                        "key": "01-question-14-topic",
                        "question": {
                            en: "Inter-related effects offshore (see Chapter 15 of our PEIR)",
                            cym: "Effeithiau rhyng-gysylltiedig ar y môr (edrychwch ar Bennod 15 yr adroddiad)",
                        },
                    },
                ]
            },
            {
                name: {
                    en: "Onshore",
                    cym: "Ar y tir",
                },
                url: "section-2",
                feedback_url: "page-2/",
                icon: "onshore",
                key: "02-section",
                questionKey: [
                    {
                        label: "questionTwo",
                    },
                ],
                topics: [
                    {
                        "key": "02-question-01-topic",
                        "question": {
                            en: "Human health (see Chapter 30 of our PEIR)",
                            cym: "Iechyd pobl (edrychwch ar Bennod 30 yr adroddiad)",
                        },
                    },
                    {
                        "key": "02-question-02-topic",
                        "question": {
                            en: "Socioeconomics (see Chapter 29 of our PEIR)",
                            cym: "Nodweddion economaidd-gymdeithasol (edrychwch ar Bennod 29 yr adroddiad)",
                        },
                    },
                    {
                        "key": "02-question-03-topic",
                        "question": {
                            en: "Climate change (see Chapter 28 of our PEIR)",
                            cym: "Newid yn yr hinsawdd (edrychwch ar Bennod 28 yr adroddiad)",
                        },
                    },
                    {
                        "key": "02-question-04-topic",
                        "question": {
                            en: "Traffic and transport (see Chapter 21 of our PEIR)",
                            cym: "Traffig a thrafnidiaeth (edrychwch ar Bennod 21 yr adroddiad)",
                        },
                    },
                    {
                        "key": "02-question-05-topic",
                        "question": {
                            en: "Geology, hydrogeology and ground conditions (see Chapter 16 of our PEIR)",
                            cym: "Daeareg, hydroddaeareg a chyflwr y ddaear (edrychwch ar Bennod 16 yr adroddiad)",
                        },
                    },
                    {
                        "key": "02-question-06-topic",
                        "question": {
                            en: "Hydrology and flood risk (see Chapter 17 of our PEIR)",
                            cym: "Hydroleg a pherygl llifogydd (edrychwch ar Bennod 17 yr adroddiad)",
                        },
                    },
                    {
                        "key": "02-question-07-topic",
                        "question": {
                            en: "Onshore ecology (see Chapter 18 of our PEIR)",
                            cym: "Ecoleg ar y tir (edrychwch ar Bennod 18 yr adroddiad)",
                        },
                    },
                    {
                        "key": "02-question-08-topic",
                        "question": {
                            en: "Historic environment (see Chapter 19 of our PEIR)",
                            cym: "Amgylchedd hanesyddol (edrychwch ar Bennod 19 yr adroddiad)",
                        },
                    },
                    {
                        "key": "02-question-09-topic",
                        "question": {
                            en: "Land use and recreation (see Chapter 20 of our PEIR)",
                            cym: "Defnydd tir a hamdden (edrychwch ar Bennod 20 yr adroddiad)",
                        },
                    },
                    {
                        "key": "02-question-10-topic",
                        "question": {
                            en: "Noise and vibration (see Chapter 22 of our PEIR)",
                            cym: "Sŵn a dirgryniad (edrychwch ar Bennod 22 yr adroddiad)",
                        },
                    },
                    {
                        "key": "02-question-11-topic",
                        "question": {
                            en: "Air quality (see Chapter 23 of our PEIR)",
                            cym: "Ansawdd aer (edrychwch ar Bennod 23 yr adroddiad)",
                        },
                    },
                    {
                        "key": "02-question-12-topic",
                        "question": {
                            en: "Onshore and intertidal ornithology (see Chapter 24 of our PEIR)",
                            cym: "Adareg ar y tir a rhynglanwol (edrychwch ar Bennod 24 yr adroddiad)",
                        },
                    },
                    {
                        "key": "02-question-13-topic",
                        "question": {
                            en: "Inter-related effects - onshore (see Chapter 25 of our PEIR)",
                            cym: "Effeithiau rhyng-gysylltiedig ar y tir (edrychwch ar Bennod 25 yr adroddiad)",
                        },
                    },
                    {
                        "key": "02-question-14-topic",
                        "question": {
                            en: "Seascapes, landscapes and visual resources (see Chapter 26 of our PEIR)",
                            cym: "Y morwedd, tirwedd ac adnoddau gweledol (edrychwch ar Bennod 26 yr adroddiad)",
                        },
                    },
                    {
                        "key": "02-question-15-topic",
                        "question": {
                            en: "Aviation and radar (see Chapter 27 of our PEIR)",
                            cym: "Hedfan a radar (edrychwch ar Bennod 27 yr adroddiad)",
                        },
                    },
                ],
            },
            {
                name: {
                    en: "Community",
                    cym: "Cymuned",
                },
                url: "section-3",
                feedback_url: "page-3/",
                icon: "community",
                key: "03-section",
                questionKey: [
                    {
                        label: "questionThree",
                    },
                ],
            },
            {
                name: {
                    en: "Environment",
                    cym: "Amgylchedd",
                },
                url: "section-4",
                feedback_url: "page-4/",
                icon: "environment",
                key: "04-section",
                questionKey: [
                    {
                        label: "questionFour",
                    },
                ],
            },
            {
                name: {
                    en: "Location",
                    cym: "Lleoliad",
                },
                url: "section-5",
                feedback_url: "page-5/",
                icon: "location",
                key: "05-section",
                questionKey: [
                    {
                        label: "questionFive",
                    },
                    {
                        label: "questionSix",
                    },
                    {
                        label: "questionSeven",
                    },
                    {
                        label: "questionEight",
                    },
                ],
            },
            {
                name: {
                    en: "General",
                    cym: "Cyffredinol",
                },
                url: "section-6",
                feedback_url: "page-6/",
                icon: "uncategorised",
                key: "06-section",
                questionKey: [
                    {
                        label: "questionNine",
                    },
                ],
            },
        ],
    },

    // Form field/label translations
    form: {
        feedbackSection: {
            en: "Section",
            cym: "Adran",
        },

        characterCount: {
            en: "Characters remaining",
            cym: "Cyfrif nodau",
        },

        characterCountLimitText: {
            en: "if you wish to send more content please email us",
            cym: "os hoffech anfon mwy o gynnwys anfonwch e-bost atom",
        },

        goBackButton: {
            en: "Go back",
            cym: "Mynd yn ôl",
        },

        continueButton: {
            en: "Continue",
            cym: "Parhau",
        },

        submitButton: {
            en: "Submit",
            cym: "Cyflwyno",
        },

        updateFeedback: {
            en: "Update",
            cym: "Diweddariad",
        },

        enterFeedbackPlaceholder: {
            en: "Enter your feedback",
            cym: "Rhowch eich adborth",
        },
        question: {
            en: "Question",
            cym: "Cwestiwn",
        },
        topic: {
            en: "Topic",
            cym: "Testun",
        },

        contact: {
            name: {
                en: "Name",
                cym: "Enw",
            },

            email: {
                en: "Email",
                cym: "Ebost",
            },

            registerForEvent: {
                en: "To register for our online event, please leave your details and tick this box",
                cym: "I gofrestru ar gyfer ein digwyddiad ar-lein, gadewch eich manylion a thiciwch y blwch hwn",
            },

            message: {
                en: "Message",
                cym: "Neges",
            },

            projectProgress: {
                en: "I wish to be kept informed",
                cym: "Hoffwn gael fy hysbysu",
            },

            send: {
                en: "Send",
                cym: "Anfon",
            },
        },

        yourDetails: {
            name: {
                en: "Name",
                cym: "Enw",
            },

            address: {
                en: "Address",
                cym: "Cyfeiriad",
            },

            postcode: {
                en: "Postcode",
                cym: "Côd post",
            },

            phone: {
                en: "Phone",
                cym: "Ffon",
            },

            email: {
                en: "Email",
                cym: "E-bost",
            },

            behalfOrganisation: {
                en: "Are you responding on behalf of an organisation?",
                cym: "Cwmni/Sefydliad, lle bo hynny’n berthnasol (dewisol)",

                yes: {
                    en: "Yes",
                    cym: "le",
                },

                no: {
                    en: "No",
                    cym: "Na",
                },
            },

            organisation: {
                en: "Organisation",
                cym: "Sefydliad",

                placeholder: {
                    en: "If yes, which one?",
                    cym: "Os oes, pa un?",
                },
            },

            upToDate: {
                en: "Please indicate your area(s) of interest:",
                cym: "Please indicate your area(s) of interest:",
            },

            projectProgress: {
                en: "Please keep me informed of the project's progress",
                cym: "Cofiwch roi gwybod i mi am gynnydd y prosiect.",
            },

            projectProgress: {
                en: "Project progress",
                cym: "Gynnydd y prosiect",
            },

            projectProgressCommunity: {
                en: "Community updates",
                cym: "Community updates",
            },
        },

        error: {
            firstName: {
                en: "Please enter your first name",
                cym: "Rhowch eich enw cyntaf",
            },

            lastName: {
                en: "Please enter your last name",
                cym: "Rhowch eich enw olaf",
            },

            postcode: {
                en: "Please enter your postcode",
                cym: "Rhowch eich cod post",
            },

            email: {
                en: "Please check your email address is formatted correctly.",
                cym: "Gwiriwch fod eich cyfeiriad e-bost wedi'i fformatio'n gywir.",
            },

            submittingFeedback: {
                en: "Sorry, there was an error trying to send your feedback, please check your submission and try again. If the problem persists please contact us on ",
                cym: "Mae'n ddrwg gennym, roedd gwall wrth geisio anfon eich adborth, gwiriwch eich cyflwyniad a rhowch gynnig arall arni. Os bydd y broblem yn parhau, cysylltwch â ni ar",
            },

            checkFieldsComplete: {
                en: "Please check that you have completed all required fields. If so and the problem persists, please contact us on ",
                cym: "Gwiriwch eich bod wedi cwblhau pob maes gofynnol. Os felly a bod y broblem yn parhau, cysylltwch â ni ar ",
            },

            required: {
                en: "is required",
                cym: "yn ofynnol"
            }
        },
    },

    changeRequest: {
        title: {
			en: "Change request",
			cym: "Cais am Newid"
		},

		downloads: [
			{
				title: {
				    en: "Notice of proposed changes to the development consent order application",
				    cym: "Hysbysiad ynghylch newidiadau arfaethedig i'r cais am orchymyn cydsyniad datblygu",
				},

				url: {
				    en: "/assets/files/Mona-RfC-RLB-notice-Rev4-ENG.pdf",
				    cym: "/assets/files/Mona-RfC-RLB-notice-Rev4-CYM.pdf",
				}
			},

			{
				title: {
				    en: "Mona Change Request",
				    cym: "Mona Change Request",
				},

				url: {
				    en: "/assets/files/CR-plan.png",
				    cym: "/assets/files/CR-plan.png",
				}
			},

			{
				title: {
				    en: "Mona Change Request Report",
				    cym: "Mona Change Request Report",
				},

				url: {
				    en: "/assets/files/S_CR_2_Mona_Change_Request_Report.pdf",
				    cym: "/assets/files/S_CR_2_Mona_Change_Request_Report.pdf",
				}
			},

			{
				title: {
				    en: "Change Request Location Plan",
				    cym: "Change Request Location Plan",
				},

				url: {
				    en: "/assets/files/S_CR_3_Change_Request_Location_Plan.pdf",
				    cym: "/assets/files/S_CR_3_Change_Request_Location_Plan.pdf",
				}
			},

			{
				title: {
				    en: "Change Request Works Plan Onshore",
				    cym: "Change Request Works Plan Onshore",
				},

				url: {
				    en: "/assets/files/S_CR_4_Change_Request_Works_Plan_Onshore.pdf",
				    cym: "/assets/files/S_CR_4_Change_Request_Works_Plan_Onshore.pdf",
				}
			},

			{
				title: {
				    en: "Change Request Land Plan",
				    cym: "Change Request Land Plan",
				},

				url: {
				    en: "/assets/files/S_CR_5_Change_Request_Land_Plan.pdf",
				    cym: "/assets/files/S_CR_5_Change_Request_Land_Plan.pdf",
				}
			},

			{
				title: {
				    en: "Change Request Street Works & Access to Works Plan",
				    cym: "Change Request Street Works & Access to Works Plan",
				},

				url: {
				    en: "/assets/files/S_CR_6_Change_Request_Street_Works_&_Access_to_Works_Plan.pdf",
				    cym: "/assets/files/S_CR_6_Change_Request_Street_Works_&_Access_to_Works_Plan.pdf",
				}
			},

			{
				title: {
				    en: "Change Request Book of Reference",
				    cym: "Change Request Book of Reference",
				},

				url: {
				    en: "/assets/files/S_CR_7_Change_Request_Book_of_Reference.pdf",
				    cym: "/assets/files/S_CR_7_Change_Request_Book_of_Reference.pdf",
				}
			},

			{
				title: {
				    en: "Change Request Funding Statement",
				    cym: "Change Request Funding Statement",
				},

				url: {
				    en: "/assets/files/S_CR_8_Change_Request_Funding_Statement.pdf",
				    cym: "/assets/files/S_CR_8_Change_Request_Funding_Statement.pdf",
				}
			},

			{
				title: {
				    en: "Change Request Statement of Reasons",
				    cym: "Change Request Statement of Reasons",
				},

				url: {
				    en: "/assets/files/S_CR_9_Change_Request_Statement_of_Reasons.pdf",
				    cym: "/assets/files/S_CR_9_Change_Request_Statement_of_Reasons.pdf",
				}
			},

			{
				title: {
				    en: "Change Request Land Rights Tracker",
				    cym: "Change Request Land Rights Tracker",
				},

				url: {
				    en: "/assets/files/S_CR_10_Change_Request_Land_Rights_Tracker.pdf",
				    cym: "/assets/files/S_CR_10_Change_Request_Land_Rights_Tracker.pdf",
				}
			},

			{
				title: {
				    en: "Change Request Draft Development Consent Order",
				    cym: "Change Request Draft Development Consent Order",
				},

				url: {
				    en: "/assets/files/S_CR_11_Change_Request_Draft_Development_Consent_Order.pdf",
				    cym: "/assets/files/S_CR_11_Change_Request_Draft_Development_Consent_Order.pdf",
				}
			},

			{
				title: {
				    en: "Schedule of Changes to the Change Request",
				    cym: "Schedule of Changes to the Change Request",
				},

				url: {
				    en: "/assets/files/S_CR_12_Schedule_of_Changes_to_the_Change_Request.pdf",
				    cym: "/assets/files/S_CR_12_Schedule_of_Changes_to_the_Change_Request.pdf",
				}
			},

			{
				title: {
				    en: "Mona Schedule of Application Documents",
				    cym: "Mona Schedule of Application Documents",
				},

				url: {
				    en: "/assets/files/S_CR_13_Mona_Schedule_of_Application_Documents.pdf",
				    cym: "/assets/files/S_CR_13_Mona_Schedule_of_Application_Documents.pdf",
				}
			},

			{
				title: {
				    en: "Change Request Outline Construction Traffic Management Plan",
				    cym: "Change Request Outline Construction Traffic Management Plan",
				},

				url: {
				    en: "/assets/files/S_CR_15_Change_Request_Outline_Construction_Traffic_Management_Plan.pdf",
				    cym: "/assets/files/S_CR_15_Change_Request_Outline_Construction_Traffic_Management_Plan.pdf",
				}
			}
	    ]
    },

    examination: {
		index: 17,

		title: {
			en: "Examination",
			cym: "Archwiliad"
		},

		downloads: [
            {
				title: {
				    en: "Notice of Issue - Specific hearing and compulsory acquisition hearing - December 2024",
				    cym: "Hysbysiad o wrandawiad mater penodol a gwrandawiad caffael gorfodol - Rhagfyr 2024",
				},

				url: {
				    en: "/assets/files/ENG-Mona-acquisition-hearing.pdf",
				    cym: "/assets/files/CYM-Mona-acquisition-hearing.pdf",
				},
			},

            {
				title: {
				    en: "Notice of Issue - Specific hearings and compulsory acquisition hearing - Oct 2024",
				    cym: "Hysbysiad o wrandawiadau - materion penodol a gwrandawiad caffael gorfodol - Hydref 2024",
				},

				url: {
				    en: "/assets/files/ENGLISH-Mona-Oct-Hearings-notice.pdf",
				    cym: "/assets/files/CYMRAEG-Mona-Hydref-Hearings-hysbysiad.pdf",
				},
			},

			{
				title: {
				    en: "Notice of Issue - Specific Hearings and Open-Floor Hearings - July 2024",
				    cym: "Hysbysiad am Wrandawiadau Materion Penodol a Gwrandawiadau Llawr Agored - Gorffennaf 2024",
				},

				url: {
				    en: "/assets/files/Mona-First-Hearings-notice-ENG.pdf",
				    cym: "/assets/files/Mona-First-Hearings-notice-CYM.pdf",
				},
			}
	    ]
    },

    acceptance: {
		index: 0,

		title: {
			en: "Acceptance",
			cym: "Derbyn"
		},

		downloads: [
			{
				title: {
				    en: "Mona Offshore Wind Ltd Section 56 Planning Act 2008",
				    cym: "Mona Offshore Wind Ltd Adran 56 Deddf Cynllunio 2008",
				},

				url: {
				    en: "/assets/files/FINAL-Mona-s56-notice.pdf",
				    cym: "/assets/files/FINAL-Mona-s56-notice-CYM.pdf",
				},
			}

	    ]
    },

	postConsultationMaterials: {
		index: 1,

		title: {
			en: "Post consultation announcement materials",
			cym: "Deunyddiau datganiadau ôl-ymgynghori"
		},

		downloads: [
			{
				title: {
				    en: "Mona Offshore Wind Project Autumn 2023 Newsletter",
				    cym: "Cylchlythyr Prosiect Gwynt Alltraeth Mona Hydref 2023",
				},

				url: {
				    en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/MONA_GEN_Newsletter.pdf",
				    cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/MONA_GEN_Newsletter.pdf",
				},
			},

			{
				title: {
				    en: "Mona Onshore Substation Announcement Newsletter",
				    cym: "Cylchlythyr Cyhoeddi Is-orsaf Ar y Tir Mona",
				},

				url: {
				    en: "/assets/files/MONA-Onshore-Substation-announcement-newsletter.pdf",
				    cym: "/assets/files/MONA-Onshore-Substation-announcement-newsletter.pdf",
				},
			}
	    ]
    },

	statConsultationMaterials: {
		plansDrawings: {
			index: 2,

			title: {
				en: "Plans and Drawings",
				cym: "Cynlluniau a Darluniau"
			},

			downloads: [
				{
					title: {
						en: "Location plan(s) - Onshore and Offshore Plan",
						cym: "Location plan(s) - Onshore and Offshore Plan"
					},

					url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/01+Plans+and+Drawings/RPS_EOR0801_Mona_Location+Plan_FINAL.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/01+Plans+and+Drawings/RPS_EOR0801_Mona_Location+Plan_FINAL.pdf",
					}
				},
				{
					title: {
						en: "Works Plans - Onshore",
						cym: "Works Plans - Onshore"
					},

					url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/01+Plans+and+Drawings/RPS_EOR0801_Mona_Works+Plans-Onshore.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/01+Plans+and+Drawings/RPS_EOR0801_Mona_Works+Plans-Onshore.pdf",
					}
				},
				{
					title: {
						en: "Works Plans - Offshore",
						cym: "Works Plans - Offshore"
					},

					url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/01+Plans+and+Drawings/RPS_EOR0801_Mona_Works+Plans-Offshore+FINAL.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/01+Plans+and+Drawings/RPS_EOR0801_Mona_Works+Plans-Offshore+FINAL.pdf",
					}
				},
				{
					title: {
						en: "Indicative Extent of Marine Licences ",
						cym: "Indicative Extent of Marine Licences "
					},

					url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/01+Plans+and+Drawings/RPS_EOR0801_Mona_IEML.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/01+Plans+and+Drawings/RPS_EOR0801_Mona_IEML.pdf",
					}
				}
			]
		},

		dco: {
			index: 3,

			title: {
				en: "Development Consent Order",
				cym: "Gorchymyn Cydsyniad Datblygu"
			},

			downloads: [
				{
					title: {
						en: "Draft Development Consent Order including Draft Deemed Marine Licences  ",
						cym: "Draft Development Consent Order including Draft Deemed Marine Licences  "
					},

					url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/02+Development+Consent+Order/Mona_Draft_DCO.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/02+Development+Consent+Order/Mona_Draft_DCO.pdf",
					}
				},
				{
					title: {
						en: "Explanatory Memorandum ",
						cym: "Explanatory Memorandum "
					},

					url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/02+Development+Consent+Order/Mona_Draft+DCO+Explanatory+Note.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/02+Development+Consent+Order/Mona_Draft+DCO+Explanatory+Note.pdf",
					}
				}

			]
		},

		reports: {
			index: 4,

			title: {
				en: "Reports",
				cym: "Adroddiadau"
			},

			downloads: [
				{
					title: {
						en: "Information to Support Appropriate Assessment",
						cym: "Information to Support Appropriate Assessment"
					},

					url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/03+Reports/RPS_EOR0801_Mona_Other_ISAA_Final.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/03+Reports/RPS_EOR0801_Mona_Other_ISAA_Final.pdf"
					}
				},

				{
					title: {
						en: "HRA Screening Report, Screening Matrices and Integrity Matrices",
						cym: "HRA Screening Report, Screening Matrices and Integrity Matrices"
					},

					url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/03+Reports/EOR0801_Mona_HRA+Screening+FINAL.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/03+Reports/EOR0801_Mona_HRA+Screening+FINAL.pdf"
					}
				},

				{
					title: {
						en: "Marine Conservation Zone Assessment",
						cym: "Marine Conservation Zone Assessment"
					},

					url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/03+Reports/RPS_EOR0801_Mona_PEIR_MCZ_Screening.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/03+Reports/RPS_EOR0801_Mona_PEIR_MCZ_Screening.pdf"
					}
				},

			]
		},

		outlinePlans: {
			index: 5,

			title: {
				en: "Outline Plans",
				cym: "Cynlluniau Amlinellol"
			},

			downloads: [
				{
					title: {
						en: "Outline Code of Construction Practice",
						cym: "Outline Code of Construction Practice"
					},

					url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/05+Outline+Plans/RPS_EOR0801_Mona_PEIR_CoCP.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/05+Outline+Plans/RPS_EOR0801_Mona_PEIR_CoCP.pdf"
					}
				}
			]
		},


		pier: {
			title: {
				en: "PEIR",
				cym: "PEIR"
			},

			introduction: {
				index: 6,
				title: {
				    en: "PEIR Volume 1: Introductory Chapters",
				    cym: "PEIR Cyfrol 1: Penodau Rhagarweiniol",
				},

				downloads: [
				    {
					  title: {
						en: "1. Introduction and Overarching Glossary",
						cym: "1. Introduction and Overarching Glossary",
					  },

						url: {
							en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Mona_PEIR_Vol1_1_Intro.pdf",
							cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Mona_PEIR_Vol1_1_Intro.pdf"
						}
				    },

				    {
					  title: {
						en: "2. Policy and Legislation",
						cym: "2. Policy and Legislation",
					  },

					    url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Mona_PEIR_Vol1_+2_Policy.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Mona_PEIR_Vol1_+2_Policy.pdf"
					}
				    },

				    {
					  title: {
						en: "3. Project Description",
						cym: "3. Project Description",
					  },

					    url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Mona_PEIR_Vol1_3_PD.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Mona_PEIR_Vol1_3_PD.pdf"
					}
				    },

				    {
                        title: {
                          en: "4.  Site selection and alternatives",
                          cym: "4.  Site selection and alternatives",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Mona_PEIR_Vol1_4_+SSA.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Mona_PEIR_Vol1_4_+SSA.pdf"
                      }
                    },
				    {
					  title: {
						en: "5. Environmental Impact Assessment Methodology",
						cym: "5. Environmental Impact Assessment Methodology",
					  },

					    url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Mona_PEIR_Vol1_5_EIA+Method+FINAL.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Mona_PEIR_Vol1_5_EIA+Method+FINAL.pdf"
					    }
				    },
				],
			  },

			  offshoreChapters: {
				index: 7,
				title: {
				    en: "PEIR Volume 2: Offshore Chapters",
				    cym: "PEIR Cyfrol 2: Penodau ar y môr",
				},

				downloads: [
				    {
					  title: {
						en: "6. Physical Processes",
						cym: "6. Physical Processes",
					  },

						url: {
							en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_6_PP+FINAL.pdf",
							cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_6_PP+FINAL.pdf"
						}
				    },

				    {
					  title: {
						en: "7. Benthic Subtidal and Intertidal Ecology",
						cym: "7. Benthic Subtidal and Intertidal Ecology",
					  },

					    url: {
						    en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_+Mona_PEIR_Vol2_7+_BE.pdf",
						    cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_+Mona_PEIR_Vol2_7+_BE.pdf"
					    }
				    },

				    {
					  title: {
						en: "8. Fish and Shellfish Ecology",
						cym: "8. Fish and Shellfish Ecology",
					  },

					    url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_8_FSF.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_8_FSF.pdf"
					}
				    },

				    {
					  title: {
						en: "9. Marine Mammals",
						cym: "9. Marine Mammals",
					  },

					    url: {
						en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_9_MM_FINAL.pdf",
						cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_9_MM_FINAL.pdf"
					}
				    },

				    {
                        title: {
                          en: "10. Offshore Ornithology",
                          cym: "10. Offshore Ornithology",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_10_OO+FINAL.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_10_OO+FINAL.pdf"
                      }
                    },
				    {
                        title: {
                          en: "11. Commercial Fisheries",
                          cym: "11. Commercial Fisheries",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_11_CF+FINAL.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_11_CF+FINAL.pdf"
                      }
                    },
				    {
                        title: {
                          en: "12. Shipping and Navigation",
                          cym: "12. Shipping and Navigation",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_PEIR_Mona_Vol2_12_SN.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_PEIR_Mona_Vol2_12_SN.pdf"
                      }
                    },
				    {
                        title: {
                          en: "13. Marine Archaeology",
                          cym: "13. Marine Archaeology",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_13_MAR.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_13_MAR.pdf"
                      }
                    },
				    {
                        title: {
                          en: "14. Other Sea Users",
                          cym: "14. Other Sea Users",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_14_OSU.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_14_OSU.pdf"
                      }
                    },
				    {
                        title: {
                          en: "15. Inter-related Effects - Offshore",
                          cym: "15. Inter-related Effects - Offshore",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_15_Inter-related.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol2_15_Inter-related.pdf"
                      }
                    }
				],
			  },

			  onshoreChapters: {
				  index: 8,
				  title: {
				    en: "PEIR Volume 3: Onshore Chapters",
				    cym: "PEIR Cyfrol 3: Penodau ar y tir",
				  },

				  downloads: [
				    {
                        title: {
                          en: "16. Geology, Hydrogeology and Ground Conditions",
                          cym: "16. Geology, Hydrogeology and Ground Conditions",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_16_GHGC.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_16_GHGC.pdf"
                      }
                    },
				    {
                        title: {
                          en: "17. Hydrology and Flood Risk",
                          cym: "17. Hydrology and Flood Risk",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_17_HFR.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_17_HFR.pdf"
                      }
                    },
				    {
                        title: {
                          en: "18. Onshore Ecology",
                          cym: "18. Onshore Ecology",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_18_OnEcol.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_18_OnEcol.pdf"
                      }
                    },
				    {
                        title: {
                          en: "19. Historic Environment",
                          cym: "19. Historic Environment",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_+EOR0801_Mona_PEIR_Vol+3_19_HistEnv.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_+EOR0801_Mona_PEIR_Vol+3_19_HistEnv.pdf"
                      }
                    },
				    {
                        title: {
                          en: "20. Land Use and Recreation",
                          cym: "20. Land Use and Recreation",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_20_LUR.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_20_LUR.pdf"
                      }
                    },
				    {
                        title: {
                          en: "21. Traffic and Transport",
                          cym: "21. Traffic and Transport",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_21_Traffic.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_21_Traffic.pdf"
                      }
                    },
				    {
                        title: {
                          en: "22. Noise and Vibration",
                          cym: "22. Noise and Vibration",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_22_NV.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_22_NV.pdf"
                      }
                    },
				    {
                        title: {
                          en: "23. Air Quality",
                          cym: "23. Air Quality",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_23_AQ.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_23_AQ.pdf"
                      }
                    },
				    {
                        title: {
                          en: "24. Onshore and Intertidal Ornithology",
                          cym: "24. Onshore and Intertidal Ornithology",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_24_Onshore_IO.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_24_Onshore_IO.pdf"
                      }
                    },
				    {
                        title: {
                          en: "25. Inter-related Effects - Onshore",
                          cym: "25. Inter-related Effects - Onshore",
                        },

                          url: {
                          en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_25_IRE_Onshore.pdf",
                          cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/03+-+Onshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol3_25_IRE_Onshore.pdf"
                      }
                    }
				  ]
			  },

			  onshoreOffshoreChapters: {
				  index: 9,
				  title: {
					en: "PEIR Volume 4: Onshore and Offshore Chapters",
					cym: "PEIR Cyfrol 4: Penodau cyfunol ar y môr ac ar y tir ",
				  },

				  downloads: [
					  {
						  title: {
							  en: "26. Seascape, Landscape and Visual Resources",
							  cym: "26. Seascape, Landscape and Visual Resources"
						  },

						  url: {
							  en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/04+-+Onshore+and+offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol4_26_SLVIA+(Combined+with+Plan+1%2C2%2C3).pdf",
							  cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/04+-+Onshore+and+offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol4_26_SLVIA+(Combined+with+Plan+1%2C2%2C3).pdf"
						  }
					  },
					  {
                        title: {
                            en: "27. Aviation and Radar",
                            cym: "27. Aviation and Radar"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/04+-+Onshore+and+offshore+Chapters/RPS_EOR0801_+Mona_PEIR_Vol4_27_Aviation.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/04+-+Onshore+and+offshore+Chapters/RPS_EOR0801_+Mona_PEIR_Vol4_27_Aviation.pdf"
                        }
                    },
                    {
                        title: {
                            en: "28. Climate Change ",
                            cym: "28. Climate Change "
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/04+-+Onshore+and+offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol4_28_CC.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/04+-+Onshore+and+offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol4_28_CC.pdf"
                        }
                    },
                    {
                        title: {
                            en: "29. Socio-economics",
                            cym: "29. Socio-economics"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/04+-+Onshore+and+offshore+Chapters/RPS_EOR0801_Mona+PEIR_Vol4_29_Socio-ec.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/04+-+Onshore+and+offshore+Chapters/RPS_EOR0801_Mona+PEIR_Vol4_29_Socio-ec.pdf"
                        }
                    },
                    {
                        title: {
                            en: "30. Human Health Assessment",
                            cym: "30. Human Health Assessment"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/04+-+Onshore+and+offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol4_30_HH.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/04+-+Onshore+and+offshore+Chapters/RPS_EOR0801_Mona_PEIR_Vol4_30_HH.pdf"
                        }
                    },

				  ]
			  },

			  introductionAnnexes: {
				  index: 10,
				  title: {
					en: "PEIR Volume 5: Introductory Annexes",
					cym: "PEIR Cyfrol 5: Atodiadau cyflwyno",
				  },

				  downloads: [
					  {
						  title: {
							  en: "3.1 Underwater Sound Technical Report",
							  cym: "3.1 Underwater Sound Technical Report"
						  },

						  url: {
							  en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/05+-+Introductory+Annexes/RPS_EOR0801_Mona_PEIR_Vol5_3.1_UWS+TR+FINAL.pdf",
							  cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/05+-+Introductory+Annexes/RPS_EOR0801_Mona_PEIR_Vol5_3.1_UWS+TR+FINAL.pdf"
						  }
					  },

					  {
						  title: {
							  en: "4.1 Site Selection Area of Search Identification",
							  cym: "4.1 Site Selection Area of Search Identification"
						  },

						  url: {
							  en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/05+-+Introductory+Annexes/Annex+04.1_Site+Selection+Area+of+Search+Identification.pdf",
							  cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/05+-+Introductory+Annexes/Annex+04.1_Site+Selection+Area+of+Search+Identification.pdf"
						  }
					  },

					  {
						title: {
							en: "4.2 Site Selection Shortlisting BRAG Report",
							cym: "4.2 Site Selection Shortlisting BRAG Report"
						},

						url: {
							en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/05+-+Introductory+Annexes/Annex+04.2_+SSA+Onshore+Substation+BRAG.pdf",
							cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/05+-+Introductory+Annexes/Annex+04.2_+SSA+Onshore+Substation+BRAG.pdf"
						}
					},
                    {
						title: {
							en: "5.1 Cumulative Effects Screening Matrix",
							cym: "5.1 Cumulative Effects Screening Matrix"
						},

						url: {
							en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/05+-+Introductory+Annexes/RPS_EOR0801_Mona_PEIR_Vol5_5.1_CEA+Matrix.pdf",
							cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/05+-+Introductory+Annexes/RPS_EOR0801_Mona_PEIR_Vol5_5.1_CEA+Matrix.pdf"
						}
					},
                    {
						title: {
							en: "5.2 Transboundary Impacts Screening",
							cym: "5.2 Transboundary Impacts Screening"
						},

						url: {
							en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/05+-+Introductory+Annexes/RPS_EOR0801_Mona_PEIR_Vol5_5.2_Transboundary.pdf",
							cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/05+-+Introductory+Annexes/RPS_EOR0801_Mona_PEIR_Vol5_5.2_Transboundary.pdf"
						}
					}
				  ]
			  },

			  offshoreAnnexes: {
				  index: 11,
				  title: {
					en: "PEIR Volume 6: Offshore Annexes",
					cym: "PEIR Cyfrol 6: Atodiadau ar y môr",
				  },

				  downloads: [
					  {
						  title: {
							  en: "6.1 Physical Processes Technical Report",
							  cym: "6.1 Physical Processes Technical Report"
						  },

						  url: {
							  en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_+6.1_+PPTR+FINAL.pdf",
							  cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_+6.1_+PPTR+FINAL.pdf"
						  }
					  },
					  {
                        title: {
                            en: "7.1 Benthic Subtidal and Intertidal Ecology Technical Report",
                            cym: "7.1 Benthic Subtidal and Intertidal Ecology Technical Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_7.1_BE_TR.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_7.1_BE_TR.pdf"
                        }
                    },
                    {
                        title: {
                            en: "7.2 Water Framework Directive Coastal Waters Assessment",
                            cym: "7.2 Water Framework Directive Coastal Waters Assessment"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/EOR0801_Mona_PEIR_Vol6_7.2_WFD+Coast+FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/EOR0801_Mona_PEIR_Vol6_7.2_WFD+Coast+FINAL.pdf"
                        }
                    },
                    {
                        title: {
                            en: "8.1 Fish and Shellfish Ecology Technical Report",
                            cym: "8.1 Fish and Shellfish Ecology Technical Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/EOR0801_Mona_PEIR_Vol6_8.1_FSF+TR+FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/EOR0801_Mona_PEIR_Vol6_8.1_FSF+TR+FINAL.pdf"
                        }
                    },
                    {
                        title: {
                            en: "9.1 Marine Mammal Technical Report ",
                            cym: "9.1 Marine Mammal Technical Report "
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_9.1_MMTR+FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_9.1_MMTR+FINAL.pdf"
                        }
                    },
                    {
                        title: {
                            en: "10.1 Offshore Ornithology Baseline Characterisation Technical Report",
                            cym: "10.1 Offshore Ornithology Baseline Characterisation Technical Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_10.1_OO+Baseline+TR+FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_10.1_OO+Baseline+TR+FINAL.pdf"
                        }
                    },
                    {
                        title: {
                            en: "10.2 Offshore Ornithology Displacement Technical Report",
                            cym: "10.2 Offshore Ornithology Displacement Technical Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_10.2_OODisplacement+TR.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_10.2_OODisplacement+TR.pdf"
                        }
                    },
                    {
                        title: {
                            en: "10.3 Offshore Ornithology Collision Risk Modelling Technical Report",
                            cym: "10.3 Offshore Ornithology Collision Risk Modelling Technical Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_10.3_OO_CRM+TR_FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_10.3_OO_CRM+TR_FINAL.pdf"
                        }
                    },
                    {
                        title: {
                            en: "10.4 Offshore Ornithology Migratory Bird Collision Risk Modelling Technical Report ",
                            cym: "10.4 Offshore Ornithology Migratory Bird Collision Risk Modelling Technical Report "
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_10.4_OO+Migratory+CRM+TR+FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_10.4_OO+Migratory+CRM+TR+FINAL.pdf"
                        }
                    },
                    {
                        title: {
                            en: "10.5 Offshore Ornithology Apportioning Technical Report",
                            cym: "10.5 Offshore Ornithology Apportioning Technical Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_10.5_OOApportioningTR_FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_10.5_OOApportioningTR_FINAL.pdf"
                        }
                    },
                    {
                        title: {
                            en: "10.6 Offshore Ornithology Cumulative Effects Assessment Population Viability Assessment Technical Report",
                            cym: "10.6 Offshore Ornithology Cumulative Effects Assessment Population Viability Assessment Technical Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_10.6_OO_CPVA.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_10.6_OO_CPVA.pdf"
                        }
                    },
                    {
                        title: {
                            en: "11.1 Commercial Fisheries Technical Report",
                            cym: "11.1 Commercial Fisheries Technical Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_11.1_CF+TR.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_11.1_CF+TR.pdf"
                        }
                    },
                    {
                        title: {
                            en: "12.1 Navigation Risk Assessment",
                            cym: "12.1 Navigation Risk Assessment"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_12.1_NRA.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_12.1_NRA.pdf"
                        }
                    },
                    {
                        title: {
                            en: "13.1 Marine Archaeology Technical Report",
                            cym: "13.1 Marine Archaeology Technical Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_13.1_MARTR+FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/06+-+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol6_13.1_MARTR+FINAL.pdf"
                        }
                    }
				  ]
			  },

			  onshoreAnnexes: {
				index: 12,
				title: {
					en: "PEIR Volume 7: Onshore Annexes",
					cym: "PEIR Cyfrol 7: Atodiadau ar y tir",
				  },

				  downloads: [
					  {
						  title: {
							  en: "16.1 Aquifers, Groundwater Abstractions and Ground Conditions",
							  cym: "16.1 Aquifers, Groundwater Abstractions and Ground Conditions"
						  },

						  url: {
							  en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS+EOR0801+Mona+PEIR+Vol7_16.1_AqGWAbsGC+FINAL.pdf",
							  cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS+EOR0801+Mona+PEIR+Vol7_16.1_AqGWAbsGC+FINAL.pdf"
						  }
					  },
					  {
                        title: {
                            en: "17.1 Flood Consequences Assessment",
                            cym: "17.1 Flood Consequences Assessment"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7__17.1_+FCA_FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7__17.1_+FCA_FINAL.pdf"
                        }
                    },
                    {
                        title: {
                            en: "17.2 Surface Watercourses and NRW Flood Zones",
                            cym: "17.2 Surface Watercourses and NRW Flood Zones"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_17.2_SWFZ+.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_17.2_SWFZ+.pdf"
                        }
                    },
                    {
                        title: {
                            en: "17.3 Surface Water Abstraction Licences, Discharge Consents and Pollution Incidents",
                            cym: "17.3 Surface Water Abstraction Licences, Discharge Consents and Pollution Incidents"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_17.3_SWAb.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_17.3_SWAb.pdf"
                        }
                    },
                    {
                        title: {
                            en: "17.4 Water Framework Directive Surface Water and Groundwater Assessment",
                            cym: "17.4 Water Framework Directive Surface Water and Groundwater Assessment"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_17.4+WFD+FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_17.4+WFD+FINAL.pdf"
                        }
                    },
                    {
                        title: {
                            en: "18.1 Terrestrial Ecology Desk Study",
                            cym: "18.1 Terrestrial Ecology Desk Study"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_18.1_Desk+Study.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_18.1_Desk+Study.pdf"
                        }
                    },
                    {
                        title: {
                            en: "18.2 Phase 1 Habitat Survey",
                            cym: "18.2 Phase 1 Habitat Survey"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_18.2_P1HS_TR.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_18.2_P1HS_TR.pdf"
                        }
                    },
                    {
                        title: {
                            en: "18.3 Great Crested Newt Survey",
                            cym: "18.3 Great Crested Newt Survey"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_18.3_GCN+interim.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_18.3_GCN+interim.pdf"
                        }
                    },
                    {
                        title: {
                            en: "19.1 Desk Based Assessment",
                            cym: "19.1 Desk Based Assessment"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_19.1_DBA+v2.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_19.1_DBA+v2.pdf"
                        }
                    },
                    {
                        title: {
                            en: "19.2 Policy and Guidance",
                            cym: "19.2 Policy and Guidance"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_19.2_Policy+and+Guidance+FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_19.2_Policy+and+Guidance+FINAL.pdf"
                        }
                    },
                    {
                        title: {
                            en: "19.3 Onshore Geophysical Survey Report ",
                            cym: "19.3 Onshore Geophysical Survey Report "
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_Vol7_19.3_InterimGeophyssurvey.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_Vol7_19.3_InterimGeophyssurvey.pdf"
                        }
                    },
                    {
                        title: {
                            en: "19.4 Intertidal Survey Report",
                            cym: "19.4 Intertidal Survey Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_Mona_PEIR_Vol7_19.4_Intertidal+Survey+FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_Mona_PEIR_Vol7_19.4_Intertidal+Survey+FINAL.pdf"
                        }
                    },
                    {
                        title: {
                            en: "20.1 Agricultural Land Classification Published Data",
                            cym: "20.1 Agricultural Land Classification Published Data"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_20.1_ALC_Soils.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_20.1_ALC_Soils.pdf"
                        }
                    },
                    {
                        title: {
                            en: "20.2 Recreational Resources Plan",
                            cym: "20.2 Recreational Resources Plan"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_20.2_+RRPlan.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_20.2_+RRPlan.pdf"
                        }
                    },
                    {
                        title: {
                            en: "21.1 Traffic and Transport Figures",
                            cym: "21.1 Traffic and Transport Figures"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_21.1_Traffic+and+Transport+Figures.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_21.1_Traffic+and+Transport+Figures.pdf"
                        }
                    },
                    {
                        title: {
                            en: "21.2 Description of Network Links and Sensitivity",
                            cym: "21.2 Description of Network Links and Sensitivity"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_21.2_Networks.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_21.2_Networks.pdf"
                        }
                    },
                    {
                        title: {
                            en: "21.3 Public Transport Networks",
                            cym: "21.3 Public Transport Networks"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_21.3_PTN_PRINT.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_21.3_PTN_PRINT.pdf"
                        }
                    },
                    {
                        title: {
                            en: "21.4 Base Traffic Flows",
                            cym: "21.4 Base Traffic Flows"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_21.4+BTF+FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_21.4+BTF+FINAL.pdf"
                        }
                    },
                    {
                        title: {
                            en: "21.5 Personnel Injury Accident Locations",
                            cym: "21.5 Personnel Injury Accident Locations"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona+PEIR_Vol7_21.5+PIAL+FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona+PEIR_Vol7_21.5+PIAL+FINAL.pdf"
                        }
                    },
                    {
                        title: {
                            en: "22.1 Baseline Noise Survey",
                            cym: "22.1 Baseline Noise Survey"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_22.1_BaselineSound.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_22.1_BaselineSound.pdf"
                        }
                    },
                    {
                        title: {
                            en: "22.2 Construction Noise",
                            cym: "22.2 Construction Noise"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_22.2_ConstructionNoise.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_22.2_ConstructionNoise.pdf"
                        }
                    },
                    {
                        title: {
                            en: "22.3 Operational Noise Technical Report",
                            cym: "22.3 Operational Noise Technical Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_22.3_OpNoise.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_22.3_OpNoise.pdf"
                        }
                    },
                    {
                        title: {
                            en: "24.1 Onshore Ornithology - Wintering and Migratory Birds",
                            cym: "24.1 Onshore Ornithology - Wintering and Migratory Birds"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_24.1_Onshore_WMB_TR.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_24.1_Onshore_WMB_TR.pdf"
                        }
                    },
                    {
                        title: {
                            en: "24.2 Intertidal Ornithology - Wintering and Migratory Birds ",
                            cym: "24.2 Intertidal Ornithology - Wintering and Migratory Birds "
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_24.2_IO_TR+FINAL.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_24.2_IO_TR+FINAL.pdf"
                        }
                    },
                    {
                        title: {
                            en: "24.3 Onshore Ornithology - Breeding Birds",
                            cym: "24.3 Onshore Ornithology - Breeding Birds"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_24.3_OBB_TR.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/07+-+Onshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol7_24.3_OBB_TR.pdf"
                        }
                    }
				]
			  },

			  onshoreOffshoreAnnexes: {
				  index: 13,
				  title: {
					en: "PEIR Volume 8: Offshore and Onshore Combined Annexes",
					cym: "PEIR Cyfrol 8: Atodiadau cyfunol ar y môr ac ar y tir",
				  },

				  downloads: [
                    {
                        title: {
                            en: "26.1 Seascape, Landscape and Visual Resources Legislation and Planning Policy Context",
                            cym: "26.1 Seascape, Landscape and Visual Resources Legislation and Planning Policy Context"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/RPS_EOR0801_Mona+PEIR_Vol8_26.1_SLVIAPP.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/RPS_EOR0801_Mona+PEIR_Vol8_26.1_SLVIAPP.pdf"
                        }
                    },
                    {
                        title: {
                            en: "26.2 Seascape and Landscape Character Baseline Technical Report",
                            cym: "26.2 Seascape and Landscape Character Baseline Technical Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/Annex+26.2_Seascape+and+Landscape+Character+Baseline+Technical+Report.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/Annex+26.2_Seascape+and+Landscape+Character+Baseline+Technical+Report.pdf"
                        }
                    },
                    {
                        title: {
                            en: "26.3 Visual Baseline Technical Report",
                            cym: "26.3 Visual Baseline Technical Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/RPS_EOR0801_Mona+PEIR_Vol8_26.3_Visual+Baseline.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/RPS_EOR0801_Mona+PEIR_Vol8_26.3_Visual+Baseline.pdf"
                        }
                    },
                    {
                        title: {
                            en: "26.4 Seascape, Landscape and Visual Resources Impact Assessment Methodology",
                            cym: "26.4 Seascape, Landscape and Visual Resources Impact Assessment Methodology"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/Annex+26.4_Seascape%2C+Landscape+and+Visual+Resources+Impact+Assessment+Methodology.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/Annex+26.4_Seascape%2C+Landscape+and+Visual+Resources+Impact+Assessment+Methodology.pdf"
                        }
                    },
                    {
                        title: {
                            en: "27.1 Aviation and Radar Technical Report",
                            cym: "27.1 Aviation and Radar Technical Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol8_27.1_AR+TR.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol8_27.1_AR+TR.pdf"
                        }
                    },
                    {
                        title: {
                            en: "28.1 Technical Greenhouse Gas Assessment",
                            cym: "28.1 Technical Greenhouse Gas Assessment"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol8_28.1_GHG+Assessment.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol8_28.1_GHG+Assessment.pdf"
                        }
                    },
                    {
                        title: {
                            en: "28.2 Climate Change Risk Assessment",
                            cym: "28.2 Climate Change Risk Assessment"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol8_28.2_ClChange+Risk.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/RPS_EOR0801_Mona_PEIR_Vol8_28.2_ClChange+Risk.pdf"
                        }
                    },
                    {
                        title: {
                            en: "29.1 Socio-economics Technical Impact Report",
                            cym: "29.1 Socio-economics Technical Impact Report"
                        },

                        url: {
                            en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/RPS_EOR0801_PEIR_Mona_Vol8_29.1_SETR.pdf",
                            cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/04+Preliminary+Environmental+Information+Report/08+-+Onshore+and+Offshore+Annexes/RPS_EOR0801_PEIR_Mona_Vol8_29.1_SETR.pdf"
                        }
                    }
				  ]
			  },

			  nts: {
                index: 14,
                title: {
                  en: "PEIR: Non-Technical Summary",
                  cym: "PEIR: Crynodeb Annhechnegol",
                },

                downloads: [
                    {
						title: {
							en: "Preliminary Environmental Information Report - Non-Technical Summary (PDF)",
							cym: "Adroddiad Gwybodaeth Amgylcheddol Ragarweiniol - Crynodeb Annhechnegol (PDF)"
						},

						url: {
							en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/12587+-+MONA+-+PEIR+Non-Technical+Summary_v12.pdf",
							cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/12587+-+MONA+-+PEIR+NTS_Welsh_v4.pdf"
						}
					},
                    {
						title: {
							en: "Preliminary Environmental Information Report - Non-Technical Summary (WEBSITE)",
							cym: "Adroddiad Gwybodaeth Amgylcheddol Ragarweiniol - Crynodeb Annhechnegol (GWEFAN)"
						},

						url: {
							en: "https://bp-mona-nts.netlify.app",
							cym: "https://bp-mona-nts.netlify.app"
						}
					},


                ]
            },

			consultationMaterials: {
                index: 15,
                title: {
                  en: "Statutory consultation materials",
                  cym: "Deunyddiau ymgynghori statudol",
                },

                downloads: [
                    {
						title: {
							en: "Statutory consultation brochure (Single pages)",
							cym: "Llyfryn yr ymgynghoriad statudol (tudalen sengl)"
						},

						url: {
							en: "/assets/files/MONA-Brochure-V12_pages.pdf",
							cym: "/assets/files/MONA-Brochure-V10-Welsh_pages.pdf"
						}
					},
                    {
						title: {
							en: "Statutory consultation brochure (Spread pages)",
							cym: "Llyfryn yr ymgynghoriad statudol (Tudalennau Taenu)"
						},

						url: {
							en: "/assets/files/MONA-Brochure-V12.pdf",
							cym: "/assets/files/MONA-Brochure-V10-Welsh.pdf"
						}
					},
                    {
						title: {
							en: "SoCC",
							cym: "SoCC"
						},

						url: {
							en: "/assets/files/12045-MONA-SOCC-V17_pages.pdf",
							cym: "/assets/files/12045-MONA-SOCC-V17-Welsh_pages.pdf"
						}
					},
                    {
						title: {
							en: "Feedback Form",
							cym: "Ffurflen Adborth"
						},

						url: {
                            en: "/assets/files/MONA-Feedback-Form.pdf",
                            cym: "/assets/files/MONA-Feedback-Form-Welsh.pdf",
						}
					},
                    {
						title: {
							en: "Section 47",
							cym: "Adran 47"
						},

						url: {
							en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/Mona-Offshore-Wind-Project-Section-47-Notice.pdf",
							cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/Mona-Offshore-Wind-Project-Section-47-Notice-Welsh.pdf"
						}
					},
                    {
						title: {
							en: "Section 48",
							cym: "Adran 48"
						},

						url: {
							en: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/Mona-Offshore-Wind-Project-Section-48-notice.pdf",
							cym: "https://enbw-bp-consultation.s3.eu-west-2.amazonaws.com/PEIR/Mona-Offshore-Wind-Project-Section-48-NoticeWELSH.pdf"
						}
					},
                    {
						title: {
							en: "Consultation Poster",
							cym: "Poster Ymgynghori"
						},

						url: {
							en: "/assets/files/MM-Poster.pdf",
							cym: "/assets/files/MM-Poster.pdf"
						}
					},
                    {
                        title: {
                            en: "Recording of our online consultation event - 9 May 2023",
                            cym: "Recordiad o’n digwyddiad ymgynghori ar-lein - 9 Mai 2023",
                        },
                        videoId: "825444258",
                        type: "video",
					},

                ]
            },

		},
	},

	nonStatConsultationMaterials: {
		index: 16,

		title: {
			en: "Non-Statutory consultation materials",
			cym: "Deunyddiau ymgynghori anstatudol"
		},

		downloads: [
			{
				title: {
				    en: "Mona Offshore Wind Project consultation brochure (non-statutory consultation) - Summer 2022",
				    cym: "Fferm wynt ar y môr Mona Ymgynghoriad anstatudol - Haf 2022",
				},

				url: {
				    en: "/assets/files/BP-ENBW_MONA_(ENGLISH)_CON_DOC_WEB.pdf",
				    cym: "/assets/files/BP-ENBW_MONA_(WELSH)_CON_DOC_WEB.pdf",
				},
			  },

			  {
				title: {
				    en: "Mona Offshore Wind Project feedback form (non-statutory consultation) - Summer 2022",
				    cym: "Ffurflen adborth fferm wynt alltraeth Mona (ymgynghoriad anstatudol) - Haf 2022",
				},

				url: {
                    en: "/assets/files/BP-ENBW-MONA-Feedback-Form-English-Final-HR.pdf",
                    cym: "/assets/files/BP-ENBW-MONA-Feedback-Form-Welsh-Final-HR.pdf"
				},
			  },

			  {
                title: {
                    en: "Mona Offshore Wind Project webinar recording (non-statutory consultation) – July 2022",
                    cym: "Cofnodi gweminar fferm wynt alltraeth Mona (ymgynghoriad anstatudol) – Gorffennaf 2022",
                },
                videoId: "733186626",
                type: "video",
			  },

			  {
				title: {
				    en: "Mona Offshore Wind Project feedback form (substation consultation) - Autumn 2022",
				    cym: "Ffurflen adborth fferm wynt alltraeth Mona (ymgynghoriad is-orsaf) - Hydref 2022",
				},

				url: {
				    en: "/assets/files/BP-ENBW-MONA-Feedback-Form-English-Final-HR.pdf",
				    cym: "/assets/files/BP-ENBW-MONA-Feedback-Form-Welsh-Final-HR.pdf",
				},
			  },

			  {
				title: {
				    en: "Mona Offshore Wind Project consultation brochure (non-statutory consultation) - Summer 2022",
				    cym: "Fferm wynt ar y môr Mona Ymgynghoriad anstatudol - Haf 2022",
				},

				url: {
				    en: "/assets/files/BP-ENBW_MONA_(ENGLISH)_CON_DOC_WEB.pdf",
				    cym: "/assets/files/BP-ENBW_MONA_(WELSH)_CON_DOC_WEB.pdf",
				},
			  },

			  {
				title: {
				    en: "Mona Offshore Wind Project newsletter (substation consultation) - Autumn 2022",
				    cym: "Cylchlythyr fferm wynt alltraeth Mona (ymgynghoriad is-orsaf) - Hydref 2022",
				},

				url: {
				    en: "/assets/files/BP-ENBW-MONA-Newsletter-Final-LR.pdf",
				    cym: "/assets/files/BP-ENBW-MONA-Newsletter-Final-Welsh-LR.pdf",
				},
			  },

			  {
                title: {
                    en: "Mona Offshore Wind Project webinar recording (substation consultation) – Autumn 2022",
                    cym: "Cofnodi gweminar fferm wynt alltraeth Mona (ymgynghoriad ar is-orsaf) – Hydref 2022",
                },
                videoId: "759955996",
                type: "video",
			  },

			  {
				title: {
				    en: "Morecambe and Morgan consultation brochure - Autumn 2022",
				    cym: "Llyfryn ymgynghori Morecambe a Morgan - Hydref 2022",
				},

				url: {
				    en: "/assets/files/M&M-Condoc.pdf",
				    cym: "/assets/files/M&M-Condoc.pdf",
				},
			  },

			  {
				title: {
				    en: "Morgan and Morecambe Offshore Wind Farms: Transmission Assets Environmental Impact Assessment Scoping Report",
				    cym: "Ffermydd Gwynt Ar y Môr Morgan a Morecambe: Adroddiad Cwmpasu Asesiad o Effaith Amgylcheddol Asedau Trawsyrru",
				},

				url: {
				    en: "/assets/files/Scoping-Report.pdf",
				    cym: "/assets/files/Scoping-Report.pdf",
				},
			  },

			  {
				title: {
				    en: "Morgan Offshore Wind Project Environmental Impact Assessment Scoping Report",
				    cym: "Adroddiad Cwmpasu Asesiad Effaith Amgylcheddol Prosiect Gwynt ar y Môr Morgan",
				},

				url: {
				    en: "/assets/files/Morgan_Offshore_Wind_Farm_EIA_Scoping_Report.pdf",
				    cym: "/assets/files/Morgan_Offshore_Wind_Farm_EIA_Scoping_Report.pdf",
				},
			  },
			  {
				title: {
				    en: "Mona Scoping Report",
				    cym: "Adroddiad Cwmpasu Mona.",
				},

				url: {
				    en: "https://www.enbw-bp.com/static/d91eeb0545ee0229383665da1291d7e4/Mona_EIA_Scoping_Report_FINAL.pdf",
				    cym: "https://www.enbw-bp.com/static/d91eeb0545ee0229383665da1291d7e4/Mona_EIA_Scoping_Report_FINAL.pdf",
				},
			  },

	    ]
    },
};
